export default {
  activeEventsModel: state => state.activeEventsModel,
};
